import { MutationTree } from 'vuex';
import { PartiesState } from './types';

export const mutations: MutationTree<PartiesState> = {
    setData(state, payload: any) {
        state.data = payload;
        state.loading = false;
    },
    setError(state, error: any) {
        state.error = true;
        state.data = undefined;
        state.loading = false;
    },
    setLoading(state) {
        state.loading = true;
    },
};
